import type { AnyAction } from 'redux';
import { reducerWrapper } from '../../main/support/utils';
import { GET_USER_ONBOARDING_DATA } from '../actions/UserOnboardingDataActions';
import type { UserOnboardingData } from '../types/ts/userOnboardingData';

export type UserOnboardingDataState = {
  loading: boolean;
  error: any;
  data: UserOnboardingData | null;
};

export const INIT_STATE: UserOnboardingDataState = {
  loading: false,
  error: null,
  data: null,
};

function Handler(state: UserOnboardingDataState, action: AnyAction): UserOnboardingDataState {
  switch (action.type) {
    case GET_USER_ONBOARDING_DATA.response:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.data,
      };

    default:
      return state;
  }
}

const UserOnboardingDataReducer = reducerWrapper<UserOnboardingDataState, AnyAction>(INIT_STATE, Handler, {
  request: [GET_USER_ONBOARDING_DATA],
  error: [GET_USER_ONBOARDING_DATA],
  resetOn: [],
});

export default UserOnboardingDataReducer;
